module.exports = __webpack_public_path__ + "img/ChinaMobile.c0d5692c.png";